import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useNavigate } from "react-router-dom";
import { countCommaSeparatedVals } from "../../../utils/helpers";

const CommercialScheduleStoreBulkAction = ({
  commercialScheduleData,
  checkedKeys,
  setCheckedKeys,
  onDeleteStores,
  enableBulkAction = ["delete", "add"],
  ...props
}: {
  commercialScheduleData: any;
  checkedKeys: any;
  setCheckedKeys: Function;
  onDeleteStores?: Function;
  enableBulkAction?: string[];
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const ecryptedCommercialScheduleId = encryptUrl(
    `${commercialScheduleData.id}`
  );

  const addStoresToCommercialScheduleLink =
    ContentRoutes.UPDATE_COMMERCIAL_SCHEDULE.replace(
      ":id",
      ecryptedCommercialScheduleId.toString()
    );
  const navigate = useNavigate();

  function handleAddStoresToCommercialScheduleAction() {
    navigate(`${addStoresToCommercialScheduleLink}`);
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("STORE").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  return (
    <div className="item-action col-md-4 item-action">
      {UtilityServices.hasPermission("update-commercial_schedule") && (
        <>
          {enableBulkAction.includes("delete") && (
            <Button
              onClick={bulkDelete}
              title={t("DELETE") + " " + t("STORES")}
            >
              {t("DELETE")}
            </Button>
          )}

          {enableBulkAction.includes("add") &&
            commercialScheduleData.id > 0 && (
              <Button
                onClick={handleAddStoresToCommercialScheduleAction}
                title={t("ADD") + " " + t("STORES")}
              >
                {t("ADD")}{" "}
                {countCommaSeparatedVals(commercialScheduleData.store_ids) >
                  0 && t("MORE")}{" "}
              </Button>
            )}
        </>
      )}
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />

      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteStores();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
    </div>
  );
};

export default CommercialScheduleStoreBulkAction;
